import fetch from '@/utils/fetch';
// import {api_url} from "../popular/index"
const api_url = process.env.VUE_APP_API;

export const new_banner = data => fetch({//新增banner
  url: `${api_url}/banner`,
  method: 'post',
  data ,
});
export const get_banner = data => fetch({//banner列表
  url: `${api_url}/banner`,
});
export const pic_banner = data => fetch({//banner上传图片
  url: `${api_url}/auth`,
});
export const get_id = () => fetch({//banner上传图片
  url: `${api_url}/auth/id?num=1`,
});
export const show_banner = data => fetch({//显示隐藏banner
  url: `${api_url}/banner?id=${data.id}&status=${data.status}`,
  method: 'put',
});